// extracted by mini-css-extract-plugin
module.exports = {"container":"FaqSection_container__AFv1D","noDesktopPadding":"FaqSection_noDesktopPadding__Cht2p"};